export enum PosmWorkType{
    Installation,
    Repair,
    Remove,
    Replenishment,
    Maintenance
}

export const PosmWorkTypeLabels=["Installation","Repair","Remove","Replenishment","Maintenance"]